<template>
  <div>
    <table class="table table-striped table-bordered table-hover">
      <thead>
        <tr>
          <th>Enunciado</th>
          <th>Tipo</th>
          <th>Resposta obrigatória</th>
          <th>Resposta padrão</th>
          <th>Situação</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="q in questoes" :key="q._id">
          <td>{{ q.enunciado }}</td>
          <td>{{ q.tipo }}</td>
          <td>{{ q.obrigatorio ? 'Sim' : 'Não' }}</td>
          <td>{{ q.respostaPadrao ? q.respostaPadrao : '-' }}</td>
          <td>{{ q.ativo ? 'Ativo' : 'Cancelado' }}</td>
          <td>
            <RouterLink
              v-tooltip="'Editar'"
              data-test-id="link-auto-1"
              :to="'/evolucao/questao/cadastro/' + q._id"
              role="button"
              class="btn btn-xs btn-link"
            >
              <span class="fa fa-edit" />
            </RouterLink>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'QuestaoTabela',
  props: {
    questoes: {
      type: Array,
      required: true,
    },
  },
}
</script>
